import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { SecurityChange } from '@models/documents/security-change';
import { IEdgeDocument } from '@models/edge/edge-document';
import { SelectOption } from "@models/ui-models/select-options";
import {
  HistoricalTransactionComponent
} from "../../asic-forms/shares/historical-transaction/historical-transaction.component";

export enum HistoricalTransactionStepsEnum {
  TransactionType = 0,
  Balance = 1,
  Issue = 2,
  Cancellation = 3,
  TransferFrom = 4,
  TransferTo = 5,
  Subdivision = 6,
}

export type HistoricalTransactionTypes = 'issue' | 'cancellation' | 'transfer' | 'subdivision' | 'balance';

export const historicalTransactionTypeOptions: SelectOption<HistoricalTransactionTypes>[] = [
  { label: 'Balance', value: 'balance' },
  { label: 'Issue', value: 'issue' },
  { label: 'Cancellation', value: 'cancellation' },
  { label: 'Transfer', value: 'transfer' },
  { label: 'Subdivision or Consolidation', value: 'subdivision' },
];

export class HistoricalTransaction extends SecurityChange<Company> implements IEdgeDocument {
  static override readonly $type = 'HistoricalTransaction';

  constructor(data: Partial<HistoricalTransaction> = {}) {
    super(data);
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as HistoricalTransactionComponent).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as HistoricalTransactionComponent;
    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = this;

    return modalRef;
  }

  override prepareToRequest(): HistoricalTransaction {
    throw new Error('Method not implemented.');
  }
}
